'use client';

import Layout from '../../components/Layout';
import SubDocsLayout from '../../components/SubDocsLayout';
import useTranslation from '../../lib/translation';
import SEOHead from '../../components/SEOHead';

const Hosting = () => {
  const { t, lang } = useTranslation('common');

  return (
    <Layout>
      <SEOHead
        title={lang === 'lt' ? Array.isArray(t('hosting.pageTitle')) ? (t('hosting.pageTitle') as string[]).join(' ') : (t('hosting.pageTitle') as string) : 'Hosting | LB Websites'}
        description={
          lang === 'lt'
            ? Array.isArray(t('hosting.description')) ? (t('hosting.description') as string[]).join(' ') : (t('hosting.description') as string)
            : 'Fast, reliable hosting for your custom website — we handle the tech so you can focus on business.'
        }
        keywords='web hosting, website hosting, fast hosting, reliable hosting, high uptime, hosting services'
        canonicalUrl={lang === 'lt' ? '/lt/sub/hostingas' : '/sub/hosting'}
        lang={lang}
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'Service',
          name:
            lang === 'lt' ? Array.isArray(t('hosting.pageTitle')) ? (t('hosting.pageTitle') as string[]).join(' ') : (t('hosting.pageTitle') as string) : 'Hosting | LB Websites',
          description:
            lang === 'lt'
              ? Array.isArray(t('hosting.description')) ? (t('hosting.description') as string[]).join(' ') : (t('hosting.description') as string)
              : 'Fast, reliable hosting for your custom website — we handle the tech so you can focus on business.',
          url: `https://www.lbvisible.com${
            lang === 'lt' ? '/lt/sub/hostingas' : '/sub/hosting'
          }`,
          inLanguage: lang === 'lt' ? 'lt' : 'en',
          provider: {
            '@type': 'Organization',
            name: 'LB Visible',
          },
        }}
      />

      <SubDocsLayout>
        <h1 className='text-2xl sm:text-3xl font-semibold text-gray-900 dark:text-white mb-4 text-left'>
          {lang === 'lt' ? t('hosting.heading') : 'Hosting'}
        </h1>
        <p className='text-base text-gray-600 dark:text-gray-300 mb-10 text-left leading-relaxed'>
            {lang === 'lt'
              ? t('hosting.subtitle')
              : 'Every website we build comes with premium hosting included — optimized for speed, reliability, and zero maintenance on your side.'}
          </p>

          <ul className='space-y-6'>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
              <span className='font-semibold text-gray-900 dark:text-white'>
                {lang === 'lt'
                  ? t('hosting.features.speed.title')
                  : 'Fast global delivery:'}
              </span>{' '}
              {lang === 'lt'
                ? t('hosting.features.speed.desc')
                : "Your site is hosted on Vercel's edge network, ensuring fast load times from any location."}
              </div>
            </li>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
              <span className='font-semibold text-gray-900 dark:text-white'>
                {lang === 'lt'
                  ? t('hosting.features.security.title')
                  : 'No setup or maintenance'}
              </span>{' '}
              {lang === 'lt'
                ? t('hosting.features.security.desc')
                : 'We handle all the deployment, domains, SSL certificates, and uptime monitoring for you.'}
              </div>
            </li>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
              <span className='font-semibold text-gray-900 dark:text-white'>
                {lang === 'lt'
                  ? t('hosting.features.reliability.title')
                  : 'Secure & backed up'}
              </span>{' '}
              {lang === 'lt'
                ? t('hosting.features.reliability.desc')
                : 'Regular backups and modern security practices keep your site safe and stable.'}
              </div>
            </li>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
              <span className='font-semibold text-gray-900 dark:text-white'>
                {lang === 'lt'
                  ? t('hosting.features.support.title')
                  : 'Included with your plan'}
              </span>{' '}
              {lang === 'lt'
                ? t('hosting.features.support.desc')
                : 'Hosting is included in every website package — no extra cost or hosting headaches.'}
              </div>
            </li>
          </ul>
      </SubDocsLayout>
    </Layout>
  );
};

export default Hosting;
